/* import __COLOCATED_TEMPLATE__ from './stop-bulk-sync-modal-body.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();